import { DataSource } from '@unistocks/proxy/axios-client';
import { mapEnumToOptions } from '@unistocks/shared/utils/enum-utils';

export const dataSourceOptions = mapEnumToOptions(DataSource);
